'use client'

import { useTranslation } from '@/hooks/client/use-translation'

interface PageSizeSelectProps {
  pageSize: number
  options: number[]
  onChange: (pageSize: number) => void
}

// A plain-text native select beside the visible range: "3 per page" with the
// site's navy chevron and no box, so it reads as part of the sentence rather
// than a second control group. An off-list current size is listed too, so the
// control never shows a value other than the one in force.
export const PageSizeSelect = ({ pageSize, options, onChange }: PageSizeSelectProps) => {
  const { t } = useTranslation()
  const sizes = options.includes(pageSize) ? options : [...options, pageSize].sort((a, b) => a - b)
  return (
    <select
      aria-label={t('directory.pageSize.label', 'Product families per page')}
      data-tracking="ignore"
      value={pageSize}
      onChange={(event) => onChange(Number(event.target.value))}
      className="select-chevron text-navy focus-visible:outline-lapis h-[44px] cursor-pointer border-0 bg-transparent py-0 pr-6 pl-0 text-[14px] leading-[44px] font-semibold [background-position:right_0_center] [background-size:1rem_1rem] focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      {sizes.map((size) => (
        <option key={size} value={size}>
          {t('directory.pageSize.option', '{{count}} per page', { count: size })}
        </option>
      ))}
    </select>
  )
}
